// @flow
import { isUndefined } from "lodash";
import { trim } from "voca";
import createReducer from "common/reducerBase";
import { types as ats } from "../actions";
import ShutterStockRecord, {
	initialFilters,
	initialPurchase,
	getNewList,
} from "../data/ShutterStockRecord";
import consts from "../data/consts";
import type { SearchParams } from "../data/types";

export default {
	shutterStock: createReducer(ShutterStockRecord(), {

		[ats.SET_AUTH_INFO]: (state: Object, { payload }) => state.merge({
			listeningForAuth: false,
			token: payload.token,
		}),

		[ats.INIT_AUTH]: (state: Object) => state.set("listeningForAuth", true),

		[ats.SET_RESULTS_RETRIEVE_START]: (state: Object, { payload }) => state.set("currentContext", payload.context)
			.setIn(["lists", payload.context, "inProgress"], true),

		[ats.SET_RESULTS_RETRIEVE_SUCCESS]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...state.lists[payload.context],
			inProgress: false,
			items: state.lists[payload.context].items.concat(payload.response.results), // merge results (infinite-scroll)
			total: payload.response.total,
			page: payload.response.page,
		}),

		[ats.SET_SELECTION_FOR_CONTEXT]: (state: Object, { payload }) => {
			const selections = state.getIn(["lists", payload.context, "selected"]);
			const itemIsSelected = selections.includes(payload.id);
			return state.setIn(["lists", payload.context, "selected"], itemIsSelected
				? selections.filter((id) => id !== payload.id)
				: [payload.id]);
		},

		[ats.CLEAR_SELECTION_FOR_CONTEXT]: (state: Object, { payload }) => state.setIn(["lists", payload.context, "selected"], []),

		[ats.CLEAR_RESULTS_FOR_CONTEXT]: (state: Object, { payload }) => {
			const { context } = payload;

			return state.setIn(["lists", context], {
				...getNewList(),
				inProgress: state.lists[context].inProgress,
			});
		},

		[ats.SET_ACCOUNT_INFO_SUCCESS]: (state: Object, { payload }) => state.set("account", payload.account),

		[ats.SET_USER_LOGOUT_SUCCESS]: (state: Object) => state.replace(ShutterStockRecord()),

		[ats.SET_SEARCH_TERM_TEXT]: (state: Object, { payload }) => state.set("searchTermText", payload.term), // trim redundant white space

		[ats.SET_SEARCH_PARAMS]: (state: Object, { payload }: { payload: SearchParams }) => state.merge({
			maxResults: payload.maxResults || state.maxResults,
			sort: payload.sort || state.sort,
			searchTerm: !isUndefined(payload.searchTerm) ? trim(payload.searchTerm) : state.searchTerm,
			mediaType: payload.mediaType || state.mediaType,
			filters: payload.filters || state.filters,
		}, { deep: true }),

		[ats.TOGGLE_FILTERS_PANEL]: (state: Object) => state.set("filtersPanelOpen", !state.filtersPanelOpen),

		[ats.SET_CATEGORIES]: (state: Object, { payload }) => state.set("categories", payload),

		[ats.SET_ASSET_PURCHASE_DETAILS]: (state: Object, { payload }) => {
			payload.details.forEach((details) => {
				state = state.setIn(["assetsPurchaseDetails", details.id], details);

				if (details.licenceInfo && details.licenceInfo.metadata) {
					state = state.merge({
						purchase: { metadata: details.licenceInfo.metadata },
					},
					{ deep: true });
				}
			});

			return state;
		},

		[ats.SET_PURCHASE_START]: (state: Object, { payload }) => state.set("purchase", initialPurchase.merge(payload)), // reset the purchase data

		[ats.SET_PURCHASE_DETAILS]: (state: Object, { payload }) => state.merge({ purchase: payload }, { deep: true }),

		[ats.SET_PURCHASE_IN_PROGRESS]: (state: Object, { payload }) => state.set("purchaseInProgress", payload.inProgress),

		[ats.CLEAR_PURCHASE_DETAILS]: (state: Object) => state
			.set("assetsPurchaseDetails", {})
			.set("purchase", ShutterStockRecord().purchase),

		[ats.SET_PURCHASE_SUCCESS]: (state: Object, { payload }) => state.set("purchaseSuccessUrl", payload?.url || null),

		[ats.CLEAR_SEARCH_TERM]: (state: Object) => state.merge({
			searchTerm: "",
			searchTermText: "",
		}),

		[ats.CLEAR_SEARCH_FILTERS]: (state: Object) => state.merge({
			filters: initialFilters,
		}),

		[ats.RESET_MAX_RESULTS]: (state: Object) => state.set("maxResults", consts.MAX_RESULTS.SELECTION),
	}),
};
